import { Repeat } from '@griply/assets';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import {
  EmptyState,
  EmptyStateVariants,
} from 'shared/components/ui/empty-state';
import { habitsHelpLink } from 'shared/constants';
import { useOpenCreateHabitDialog } from 'shared/contexts/habit-form';

export const EmptyHabitsList: React.FC = () => {
  const { t } = useTranslation();
  const openDialog = useOpenCreateHabitDialog();

  const onAdd = () => openDialog();

  return (
    <EmptyState
      icon={Repeat}
      variant={EmptyStateVariants.Page}
      title={t('pages.habits.empty.title')}
      description={
        <Trans
          i18nKey="pages.habits.empty.description"
          components={{
            help: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content -- Trans clones this with the translated label as children
              <a
                key="help"
                href={habitsHelpLink}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
    >
      <Button
        variant={Variants.Contained}
        size={Sizes.Medium}
        color={Colors.Primary}
        tabIndex={0}
        onClick={onAdd}
      >
        {t('pages.habits.empty.button.add.label')}
      </Button>
    </EmptyState>
  );
};
